/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InfoBoxCheckDto { 
    fullVersion?: boolean;
    loyaltyProgramStatus?: InfoBoxCheckDto.LoyaltyProgramStatusEnum;
    onWaitingList?: boolean;
}
export namespace InfoBoxCheckDto {
    export type LoyaltyProgramStatusEnum = 'INVALID' | 'IN_PROGRESS' | 'VALID';
    export const LoyaltyProgramStatusEnum = {
        Invalid: 'INVALID' as LoyaltyProgramStatusEnum,
        InProgress: 'IN_PROGRESS' as LoyaltyProgramStatusEnum,
        Valid: 'VALID' as LoyaltyProgramStatusEnum
    };
}


